import React, { useState } from "react";

import { useParams, useLocation } from "react-router-dom";
import {
  Stack,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  Button,
  useDisclosure,
} from "@chakra-ui/react";

import PageDetailHeader from "components/PageDetailHeader/PageDetailHeader";

import EditUserModal from "./components/EditUserModal/EditUserModal";

import useDocumentTitle from "hooks/useDocumentTitle";
import ADMIN_USER_DETAIL_BREADCRUMB_CONSTANT from "constants/BreadCrumbConstants/AdminUserDetailBreadcrumbConstant";

import GeneralTab from "./components/GeneralTab/GeneralTab";
import AssociatedSuppliersTab from "./components/AssociatedSuppliersTab/AssociatedSuppliersTab";

import edit_icon_blue from "assets/images/icons/edit_icon_blue.png";

export default function UserDetails() {
  useDocumentTitle("User Details");

  const location = useLocation();

  const { user_id } = useParams();

  const {
    isOpen: isOpenEditModal,
    onOpen: onOpenEditModal,
    onClose: onCloseEditModal,
  } = useDisclosure();

  const [checkUpdate, setCheckUpdate] = useState(false);
  const [userData, setUserData] = useState(location?.state?.data);

  const updateUserDataState = (first_name, last_name, status) => {
    setUserData({
      ...userData,
      first_name: first_name,
      last_name: last_name,
      user_is_active: status,
    });
  };

  return (
    <div className="">
      <Stack spacing={"2rem"}>
        <EditUserModal
          isOpen={isOpenEditModal}
          onClose={onCloseEditModal}
          userDataProp={userData}
          setCheckUpdate={setCheckUpdate}
          setUserData={updateUserDataState}
        />
        <div className="flex flex-row">
          <div className="w-4/5 ">
            <PageDetailHeader
              breadCrumbList={ADMIN_USER_DETAIL_BREADCRUMB_CONSTANT}
              heading={
                userData?.first_name
                  ? `${userData?.first_name} ${userData?.last_name}`
                  : ""
              }
            />
          </div>
          <div className="w-1/5  ">
            <div className="flex flex-row justify-end h-full">
              <div className=" my-auto">
                <Button
                  variant="ghost"
                  sx={{
                    fontSize: "1rem",
                    color: "#17bab3",
                    paddingx: "1.25rem",
                  }}
                  onClick={onOpenEditModal}
                >
                  <div className="flex flex-row gap-2">
                    <img
                      className="h-5 w-5"
                      src={edit_icon_blue}
                      alt="edit icon blue"
                    />
                    Edit
                  </div>
                </Button>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div className="w-full flex flex-row justify-end"></div>
          <Tabs>
            <TabList>
              <Tab>General</Tab>
              <Tab>Associated Suppliers</Tab>
            </TabList>

            <TabPanels>
              <TabPanel>
                <GeneralTab userData={userData} />
              </TabPanel>
              <TabPanel>
                <AssociatedSuppliersTab user_id={user_id} />
              </TabPanel>
            </TabPanels>
          </Tabs>
        </div>
      </Stack>
    </div>
  );
}
